import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ChatTab } from '../ai-chat.types';

@Component({
  selector: 'app-ai-chat-tab',
  templateUrl: './ai-chat-tab.component.html',
  styleUrls: ['./ai-chat-tab.component.scss']
})
export class AiChatTabComponent {
  @Input() tab!: ChatTab;
  @Input() isActive: boolean = false;
  @Input() showCloseButton: boolean = true;
  
  @Output() tabSelected = new EventEmitter<string>();
  @Output() tabClosed = new EventEmitter<string>();
  @Output() titleEditStarted = new EventEmitter<string>();
  @Output() titleEditFinished = new EventEmitter<{chatId: string, newTitle: string}>();
  @Output() titleEditCancelled = new EventEmitter<string>();

  constructor() {}

  onTabClick() {
    if (!this.tab.isEditing)
    {
      this.tabSelected.emit(this.tab.id);
    }
  }

  onCloseClick(event: Event) {
    event.stopPropagation();
    this.tabClosed.emit(this.tab.id);
  }

  onTitleDoubleClick(event: Event) {
    event.stopPropagation();
    this.titleEditStarted.emit(this.tab.id);
  }

  onTitleKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter')
    {
      event.preventDefault();
      const input = event.target as HTMLInputElement;
      this.titleEditFinished.emit({chatId: this.tab.id, newTitle: input.value});
    }
    else if (event.key === 'Escape')
    {
      event.preventDefault();
      this.titleEditCancelled.emit(this.tab.id);
    }
  }

  onTitleBlur(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    this.titleEditFinished.emit({chatId: this.tab.id, newTitle: input.value});
  }

  get displayTitle(): string {
    if (this.tab.title.length > 15) {
      return this.tab.title.substring(0, 12) + '...';
    }
    return this.tab.title;
  }
}